var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "loaderTarget", staticClass: "d-flex w-100 my-5" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("span", { staticClass: "mx-3" }, [_vm._v(_vm._s(_vm.spinnerLabel))])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "m-auto spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }